"use strict"

module.exports = {}
